import { Column } from '@miq/catalog';
import { CurrentCatalogModel } from '@records/state/current-catalog/current-catalog.model';
import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';

export class ChangeColumnConfig implements ExecutableAction<CurrentCatalogModel> {
  static readonly type = '[Current Catalog] Change Column Config';

  constructor(
    private columnId: number,
    private columnChange: Partial<Column>
  ) {}

  execute(params: ExecutableActionParam<CurrentCatalogModel>) {
    const currentState = params.ctx.getState();
    const column = currentState.columns[this.columnId];
    if (column) {
      const { columnId: _columnId, ...modifiableChanges } = this.columnChange;
      const newColumn = { ...column, ...modifiableChanges };
      const newColumnsState = { ...currentState.columns };
      newColumnsState[this.columnId] = newColumn;
      params.ctx.patchState({ columns: newColumnsState, dirty: true });
    }
  }
}
